module.exports = __webpack_public_path__ + "static/mesh-bg-horizontal-dl-771fc0883d8f6371908a61ca7cf3b58b.png";